import React, { Component, useEffect } from "react";
import { Layout, Input, Button, Card, Typography, Form, message, Modal, Result } from "antd";
import "./styles.css";
import loginApi from './api'
import { useNavigator } from "../../utilities/navigation";
import { useMutation, useQuery } from "react-query";
import { useState } from "react";


const ForgetPassword = (props) => {
  const [navigator] = useNavigator()
  const [isModal, setIsModal] = useState(false)
  const [successMsg, setSuccessMessage] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => {
    const loggedUser = JSON.parse(localStorage.getItem("loggedUser"))
    if (loggedUser != null) {
      localStorage.removeItem("loggedUser")
    }
  })
  const mutation = useMutation(async (data) => {
    console.log(data)
    return loginApi.resetPassword(data)
  },{
    onSuccess:(data)=>{
      if(data!= null){
        localStorage.removeItem("loggedUser")
        navigator('/login')
      }

    },
    onError:(error)=>{
        message.error("Something Went Wrong.Please try again")
        // navigator('/login')
    }
  }
  )

  const resetPassword = () => {
    const password = document.getElementById("password")?.value
    const confirmPassword = document.getElementById("confirmPassword")?.value
    if (password != confirmPassword) {
      setError("Password doesn't match with confirm Password")
      setTimeout(()=>{
        setError("")
      },3000)
      return
    }

    const urlParams = new URLSearchParams(window.location.search);
    const myParam = urlParams.get("hash");
    mutation.mutateAsync({
      hash:myParam,
      password:password
    })

  }
  const { Content } = Layout;
  const { Title, Text, Link } = Typography;
  return (
    <Layout className="layout">
      <Content style={{ padding: "0 50px" }}>
        <div className="site-layout-content">
          <Card
            style={{ width: 300 }}
            bordered={true}
            className="login-container"
          >
            <Form
              className="loginForm"
              layout="vertical"
              name="nest-messages"
              onFinish={() => { }}
              validateMessages={() => { }}
            >
              <Form.Item>
                <Title level={5} className="form-title">
                  Reset Your Password
                </Title>
              </Form.Item>

              <Form.Item
                className="form-elemnt"
                name="password"
                label="Password"
              >
                <Input
                  size="large"
                  id="password"

                  autoComplete="off"
                  type="password"
                  onChange={(e) => {

                  }}
                />
                {error != '' ? <Text type="danger">{error}</Text>:null}
              </Form.Item>
              <Form.Item
                className="form-elemnt"
                name="confirmPassword"
                label="Confirm Password"
              >
                <Input
                  size="large"
                  autoComplete="off"
                  id="confirmPassword"
                  type="password"
                  onChange={(e) => {

                  }}
                />
              </Form.Item>
              <Form.Item className="submit-item">
                <Button
                  type="primary"
                  className="submit-btn"
                  htmlType="submit"
                  size="large"
                  onClick={() => {
                    resetPassword()
                  }}
                  loading={mutation.isLoading}
                >
                  Reset Password
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </div>
      </Content>
    </Layout>
  );
}


export default ForgetPassword
